module.exports = __webpack_public_path__ + "media/images/lp/ashinagasan-ad1/img_intro-heading02-pc-f9a10fd57817e4383721ad3f28c3af95.png";